/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getHistoricalStats.defs.js'
export { main as default } from './getHistoricalStats.defs.js'
